/**
 * NotFound — 2026-07-27 · Round 4 · CHANGE 22.
 *
 * Small "route not found" page rendered by the `*` catch-all route
 * in `App.js`. Explicitly typed so it does not leak engine vocabulary,
 * calibration mentions, or numeric claims.
 */
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
    return (
        <main
            className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center"
            data-testid="not-found-page"
        >
            <Compass size={48} className="text-brand mb-6" aria-hidden />
            <div className="text-[11px] uppercase tracking-widest font-semibold text-brand mb-3">
                Route not found
            </div>
            <h1 className="font-serif text-[32px] sm:text-[40px] leading-tight font-medium text-ink-1 mb-4 max-w-lg">
                That page isn&rsquo;t part of Tomauro.
            </h1>
            <p className="text-[15px] text-ink-2 leading-[1.7] max-w-md mb-8 font-serif">
                The URL may have moved or was never here to begin with.
                Head back to the home page or the analyses list.
            </p>
            <div className="flex gap-3 flex-wrap justify-center">
                <Link
                    to="/"
                    data-testid="not-found-home-link"
                    className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-[12px] font-semibold uppercase tracking-widest border border-brand bg-brand text-white hover:bg-brand-dark transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
                >
                    Home
                </Link>
                <Link
                    to="/analyses"
                    data-testid="not-found-analyses-link"
                    className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-[12px] font-semibold uppercase tracking-widest border border-border text-ink-1 hover:border-strong hover:bg-panel transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
                >
                    Analyses
                </Link>
            </div>
        </main>
    );
}
